import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import './Contact.scss';
import SectionHeading from '../SectionHeading/SectionHeading';
import { Icon } from '@iconify/react';
import SocialLinks from '../SocialLinks/SocialLinks';
import { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import { EMAILJS_CONFIG } from '../../config/emailjs';

const Contact = ({ data, socialData }) => {
  const { title, text, subTitle, contactInfo } = data;
  const formRef = useRef();
  const [formStatus, setFormStatus] = useState({ type: '', message: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setFormStatus({ type: 'info', message: 'Sending message...' });

    try {
      const result = await emailjs.sendForm(
        EMAILJS_CONFIG.SERVICE_ID,
        EMAILJS_CONFIG.TEMPLATE_ID,
        formRef.current,
        EMAILJS_CONFIG.PUBLIC_KEY
      );

      if (result.text === 'OK') {
        setFormStatus({ type: 'success', message: 'Message sent successfully! I will get back to you soon.' });
        formRef.current.reset();
      } else {
        throw new Error('Failed to send message');
      }
    } catch (error) {
      console.error('EmailJS Error:', error);
      setFormStatus({ 
        type: 'error', 
        message: 'Failed to send message. Please try again or contact me directly at randakelvin@gmail.com' 
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="st-dark-bg">
      <div className="st-height-b100 st-height-lg-b80"></div>
      <SectionHeading title="Contact" />
      <div className="container" data-aos="fade-up" data-aos-duration="800" data-aos-delay="500">
        <div className="row d-flex">
          <div className="col-lg-6">
            <h3 className="st-contact-title">Just say Hello</h3>
            {formStatus.message && (
              <div id="st-alert" className={`alert ${formStatus.type === 'success' ? 'alert-success' : formStatus.type === 'error' ? 'alert-danger' : 'alert-info'}`}>
                {formStatus.message}
              </div>
            )}
            <form ref={formRef} onSubmit={handleSubmit} className="st-contact-form" id="contact-form">
              <div className="st-form-field">
                <input type="text" id="name" name="user_name" placeholder="Your Name" required />
              </div>
              <div className="st-form-field">
                <input type="email" id="email" name="user_email" placeholder="Your Email" required />
              </div>
              <div className="st-form-field">
                <input type="text" id="subject" name="subject" placeholder="Your Subject" required />
              </div>
              <div className="st-form-field">
                <textarea cols="30" rows="10" id="message" name="message" placeholder="Your Message" required></textarea>
              </div>
              <button 
                className='st-btn st-style1 st-color1' 
                type="submit" 
                id="submit" 
                name="submit"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Sending...' : 'Send Message'}
              </button>
            </form>
            <div className="st-height-b0 st-height-lg-b30"></div>
          </div>
          <div className="col-lg-6">
            <div className="st-height-b0 st-height-lg-b40"></div>
            <h3 className="st-contact-title">{title}</h3>
            <div className="st-contact-text">{text}</div>
            <div className="st-contact-info-wrap">
              {contactInfo.map((info, index) => (
                <div className="st-single-contact-info" key={index}>
                  <div className="st-icon-wrap">
                    <Icon icon={`fa-regular:${info.icon}`} />
                  </div>
                  <div className="st-single-info-details">
                    <h4>{info.title}</h4>
                    {info.title === 'Email' ? (
                      <Link to={`mailto:${info.info}`}>{info.info}</Link>
                    ) : info.title === 'Phone' ? (
                      <Link to={`tel:${info.info}`}>{info.info}</Link>
                    ) : (
                      <span>{info.info}</span>
                    )}
                  </div>
                </div>
              ))}
              <div className="st-social-info">
                <div className="st-social-text">{subTitle}</div>
                <SocialLinks data={socialData} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="st-height-b100 st-height-lg-b80"></div>
    </section>
  )
}

Contact.propTypes = {
  data: PropTypes.object,
  socialData: PropTypes.array,
}

export default Contact;
